import React, { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import { getFaqList, inativarFaq } from '../../services/api-auto';
import ModalLoading from '../../components/ModalLoading';
import { useHistory } from 'react-router-dom';
import FaqCard from '../../components/FaqCard';
import TextField from '@material-ui/core/TextField';
import FormControl from '@material-ui/core/FormControl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { useGetUser } from '../../hooks/useGetUser';

const Faq = () => {

    const history = useHistory();
    const [faqs, setFaqs] = useState([])
    const [verMais, setVerMais] = useState(true)
    const [modalLoading, setModalLoading] = useState(false);
    const [filter, setFilter] = useState( {page : 1, pageSize: 10, query: "" } );
    const [buscar, setBuscar] = useState('')

    const getFaqs = async() => {
        setModalLoading(true)
        const data = await getFaqList(filter);
        setModalLoading(false)
        setFaqs(data.data)
    } 

    useEffect(()=> {
        (faqs && faqs.items?.length > 0 && faqs.page === faqs.totalPages ) ? setVerMais(true) : setVerMais(false); 
        getFaqs()
    },[])

    const excluir = async (Id) => {
        if(window.confirm("Deseja realmente apagar este registro?")) {
            setModalLoading(true)
            await inativarFaq(Id);
            setModalLoading(false)
            findAcoes();
        }
    }

    const addPage = async () => {
        setModalLoading(true)
        const data = await getFaqList(filter);
        setModalLoading(false)
        const f = filter;
        f.page += 1;
        setFilter(f);
        getFaqs([...faqs, ...data.data])
    }

    const findAcoes = async () => {
        const f = filter;
        f.query = buscar;
        f.page = 1;
        setFilter(f);
        const faq = await getFaqList(filter);
        setFaqs(faq.data);
    }

    const user = useGetUser();

    return (
        <>
            {( user.perfilAcesso === 'Master' ) && (
                <>
                    <div className={styles.wrapper}>
                        <div className={styles.title}>
                            FAQ
                        </div>
                        <div className={styles.buttonWrapper}>
                            <button className={`btnInvert ${styles.btAdd}`} onClick={() => {history.push('/faq/detalhe')}}>
                                Cadastrar pergunta
                            </button>
                        </div>
                        <div className={styles.subTitle}>
                            Perguntas cadastradas
                        </div>
                        <div className={styles.buscar}>
                            <FormControl>
                                <TextField  type="text"  size="small"
                                    onChange={(e) => {setBuscar(e.target.value)}}
                                    label="Faça sua busca"
                                    value={buscar}
                                    variant="filled"
                                    className="customFilledInput"
                                    onKeyDown= {
                                        (e) => {
                                            if (e.key === 'Enter') {
                                                findAcoes();
                                                e.preventDefault();
                                            }
                                        }
                                    }
                                    InputProps={{endAdornment: (
                                        <button onClick={findAcoes} className={styles.searcButton}>
                                            <FontAwesomeIcon icon={faSearch}/>
                                        </button>
                                    )}}
                                />
                            </FormControl>
                        </div>
                        <div className={styles.acoesWrapper}>
                            {faqs && faqs.items?.map(
                                (f) => <FaqCard faq={f} excluir={excluir}/>
                            )}
                        </div>
                        {
                            faqs.items?.length === 0 &&
                            <div className={styles.verMaisWrapper}> Não existem dados para exibir </div>
                        }
                        { verMais && (
                            <div className={styles.verMaisWrapper}>
                                <button className={`customButton ${styles.verMaisButton}`} onClick={addPage} >
                                    Ver mais
                                </button>
                            </div>
                        )}
                        <ModalLoading
                            open={modalLoading} 
                            size="lg"
                        />
                    </div>
                </>
            )}

        </>
    );
  
}

export default Faq;